export default "__VITE_ASSET__dfbf9c6f__"